export const SHEER_ID_EXTERNAL_USER_ID_PARAM = 'externalUserId';
export const SHEER_ID_URL_PARAM = 'sheerid_url';
export const SHEER_ID_ORIGIN = 'https://services.sheerid.com';
//# sourceMappingURL=sheerid-constants.js.map